import { IState } from 'legacy/lut/store'
import { ILookupState } from 'legacy/lut/store/state'

export const isSelectedPartnerEqual = (prev: any, next: any) => {
  return prev.selectedPartner === next.selectedPartner
}
